import React, { useEffect, useState } from "react";
import goToScreen from "../lib/goToScreen";
import YotiScreen from "../Components/YotiScreen";
import Loader from "../Components/Loader";
import refreshPage from "../lib/refreshPage";
import signOut from "../lib/signOut";
import isSiteBuilder from "../lib/isSiteBuilder";
import getStage from "../lib/getStage";
import { Button } from "react-bootstrap";
import BackgroundPhoto from "../Components/BackgroundPhoto";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function isItUbbleRedirect() {
  const urlParams = new window.URLSearchParams(window.location.search);
  if (urlParams.get("ubble_identification_id")) return true;
  return false;
}

export default function KYC({ history }) {
  document.title = "Onboarding";

  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState(null);
  const [isSumSub, setIsSumSub] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [accountTypes, setAccountTypes] = useState(null);
  // const [accountTypes, setAccountTypes] = useState(["Personal", "Business"]);

  useEffect(() => {
    if (isSiteBuilder()) {
      setTimeout(() => {
        setUrl(
          `https://api.yoti.com/idverify/v1/web/index.html?sessionID=&sessionToken=`
        );
        setLoading(false);
      }, 2000);
      return;
    }

    if (isItUbbleRedirect()) {
      return window.OrendaGetResponse(
        { event_name: "yoti session completed" },
        ({ current_screen }) => goToScreen(history, current_screen)
      );
    }

    const urlParams = new window.URLSearchParams(window.location.search);
    const account_type = urlParams.get("account_type");

    window.OrendaGetResponse(
      {
        event_name: "page load - yoti",
        data: JSON.stringify({ account_type }),
      },
      (response) => {
        if (response.sendToScreen) return;

        if (response.kyc) {
          if (response.kyc.url) {
            setUrl(response.kyc.url);
            setLoading(false);
            return;
          }
          if (response.kyc.redirect) {
            return (window.location.href = response.kyc.redirect);
          }

          // handle option if response says choose corporate/consumer
          if (response.kyc.account_types) {
            setAccountTypes(response.kyc.account_types);
            setLoading(false);
            return;
          }

          if (response.kyc.provider === "sumsub") {
            setAccessToken(response.kyc.accessToken);
            setIsSumSub(true);
            setLoading(false);
            return;
          }
        }

        if (response.ubble) {
          return (window.location.href = response.ubble.url);
          // setUrl(response.ubble.url);
          // setLoading(false);
          // return;
        }

        if (response.endeavour) {
          setUrl(response.endeavour.url);
          setLoading(false);
          return;
        }

        const { session_id, client_session_token } = response.yoti;
        setUrl(
          `https://api.yoti.com/idverify/v1/web/index.html?sessionID=${session_id}&sessionToken=${client_session_token}`
        );
        setLoading(false);
      },
      false
    );
    return;
  }, [history]);

  useEffect(() => {
    async function handleMessage(event) {
      if (
        event.origin === "https://app.shuftipro.com" &&
        event.data.verification_status
      ) {
        return window.OrendaGetResponse(
          {
            event_name: "yoti session completed",
            data: JSON.stringify({ event_data: event.data }),
          },
          ({ current_screen }) => goToScreen(history, current_screen),
          false
        );
      }

      if (event.data.message === "Session completed")
        return window.OrendaGetResponse(
          {
            event_name: "yoti session completed",
            data: JSON.stringify({ event_data: event.data }),
          },
          ({ current_screen }) => goToScreen(history, current_screen),
          false
        );

      if (event.origin === "https://api.yoti.com") {
        if (event.data.eventType === "SUCCESS") {
          // don't need a fallback as session will only work when connected to the back-end
          return window.OrendaGetResponse(
            {
              event_name: "yoti session completed",
              data: JSON.stringify({ event_data: event.data }),
            },
            ({ current_screen }) => goToScreen(history, current_screen),
            false
          );
        }
        if (event.data.eventType === "ERROR") {
          if (isSiteBuilder()) return;
          return refreshPage();
        }
      }

      // if (event?.idCheck?.applicantStatus?.reviewStatus === "pending" && event?.idCheck?.applicantStatus?.levelName === "basic-kyb-level") {
      if (event?.idCheck?.applicantStatus?.reviewStatus === "completed") {
        return window.OrendaGetResponse(
          {
            event_name: "page load - wait", // "page load - wait" ???
            // data: JSON.stringify({ event_data: event.data }),
          },
          (x) => goToScreen(history, x.account_details.current_screen),
          false
        );
      }

      return;
    }

    window.addEventListener("message", handleMessage);

    return async function cleanup() {
      window.removeEventListener("message", handleMessage);
    };
  }, [history]);

  if (loading) return <Loader />;

  if (isSumSub) {
    // window.OrendaStage = true;
    var myScript1 = document.createElement("script");
    myScript1.src =
      getStage() === "master"
        ? "https://sumsub.orenda.link"
        : "https://sumsub-dev.orenda.link";
    myScript1.type = "text/javascript";
    myScript1.SameSite = "None; Secure";
    document.head.appendChild(myScript1);
    return (
      <div style={{ width: "100vw", height: "100vh" }}>
        <div id="SumSubWidget" accessToken={accessToken}></div>
      </div>
    );
  }

  // https://usefulangle.com/post/81/javascript-change-url-parameters
  function updateUrl(input) {
    var url = new URL(window.location.href);
    var search_params = url.searchParams;

    // new value of "id" is set to "101"
    search_params.set("account_type", input);

    // change the search property of the main url
    url.search = search_params.toString();

    // the new url string
    var new_url = url.toString();

    return (window.location.href = new_url);
  }

  if (accountTypes) {
    return (
      <BackgroundPhoto>
        <div className="orenda-frontend">
          <div className="select-account">Please select the type of account you wish to apply for</div>
          <div
            style={{
              display: "flex",
              // justifyContent: "space-around",
              width: "100%",
              marginTop: "30px",
              flexWrap: "wrap",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            {accountTypes.map((x, index) => {
              return (
                <Button
                  key={index}
                  variant="dark"
                  block
                  onClick={() => updateUrl(x)}
                >
                  {x}
                </Button>
              );
            })}
          </div>
        </div>
      </BackgroundPhoto>
    );
  }

  return (
    <div style={{ width: "100vw", height: "90vh" }}>
      <YotiScreen url={url} signOut={() => signOut()} />
    </div>
  );
}
